/**
 * Main layout — wraps every authenticated page.
 *
 * Layout intentionally mirrors the Telegram mini-app: no width cap on
 * the content area (each feature page sets its own internal max-width
 * where it matters), bottom TabBar pill for navigation, and a body
 * class that gives the home tracker grid room to breathe.
 *
 * Auth gate: unauthenticated users are bounced to /login.
 */

import type { ReactNode } from 'react'
import { Outlet, Navigate } from 'react-router-dom'
import { useAuthStore } from '@turnifly/shared/stores'
import { TabBar } from '@turnifly/shared/ui'

export function MainLayout(): ReactNode {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  return (
    <div className="min-h-dvh flex flex-col bg-bg">
      <main className="flex-1 w-full">
        <Outlet />
      </main>
      <TabBar />
    </div>
  )
}
